/**
 * Routini API — Management
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TaxiTripTourAssignmentSource = {
    Manual: 'Manual',
    Greedy: 'Greedy',
    DaySolve: 'DaySolve'
} as const;
export type TaxiTripTourAssignmentSource = typeof TaxiTripTourAssignmentSource[keyof typeof TaxiTripTourAssignmentSource];

